import { ErrorHandler, Injectable, inject } from '@angular/core';

import { GlobalErrorHandlerService } from './global-error-handler.service';

@Injectable()
export class AppGlobalErrorHandler implements ErrorHandler {
  private readonly globalErrorHandlerService = inject(GlobalErrorHandlerService);

  handleError(error: unknown): void {
    this.globalErrorHandlerService.capture(error, { source: 'angular-error-handler' });
    this.globalErrorHandlerService.writeToConsole('Unhandled Angular error', error);
  }
}
